module.exports = __webpack_public_path__ + "static/grafia-c103348b64a2f45b11939c1a0b149c89.svg";